import { RootState } from 'types/store';

export const selectDeepLink = (state: RootState) => state.deepLink.url;
